import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import HtmlText from "@/sections/common/HtmlText";

import ImageContentCard, {
  IImageContentCard,
} from "@/components/cards/ImageContentCard";

// ---------------------------------------------------------------------------------

export type IPartnerSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  partners?: IImageContentCard[];
  variant?: "primary" | "secondary" | "white";
};

const bgColor = {
  primary: "bg-primary-100",
  secondary: "bg-secondary-50",
  white: "bg-white",
};

const PartnerSection: FC<IPartnerSectionProps> = (props) => {
  const {
    heading,
    description,
    partners,
    variant = "secondary",
    className,
    ...other
  } = props;

  const cardVariant = variant === "white" ? "light_primary" : "white";

  return (
    <section
      className={clsx("py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div
        className={clsx(
          variant !== "white" && "py-10 lg:py-16 xl:py-[100px]",
          bgColor[variant],
        )}
      >
        <div className="container">
          {(heading || description) && (
            <div className="mb-5 md:mb-7 lg:mb-12">
              {heading && (
                <h2 className="mb-3 text-h5 font-medium text-black-900 lg:mb-5 lg:text-h3 xl:mb-7 xl:text-h2">
                  {heading}
                </h2>
              )}

              {description && (
                <HtmlText className="prose-p:text-base prose-p:font-normal">
                  {description}
                </HtmlText>
              )}
            </div>
          )}

          {partners && partners.length > 0 && (
            <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
              {partners?.map((card, idx) => (
                <ImageContentCard
                  key={idx}
                  image={card.image}
                  icon={card.icon}
                  heading={card.heading}
                  description={card.description}
                  button={card.button}
                  variant={cardVariant}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PartnerSection;
